import { useI18n } from "utils/with-i18n.utils";

import ArrowSvg from "./arrow.svg";
import CleanSvg from "./clean.svg";
import InspectSvg from "./inspect.svg";
import ReparationSvg from "./reparation.svg";
import TestSvg from "./test.svg";

export const Reconditionning = () => {
  const i18n = useI18n();

  return (
    <div className="my-[90px]">
      <h2 className="mb-[70px] text-2xl text-center md:text-3xl">
        {i18n.t("reconditionedSmartphones.process.title", {}, { html: true })}
      </h2>

      <div className="flex flex-col gap-3 md:flex-row md:items-center">
        <div className="flex flex-col flex-1 gap-4 items-center">
          <InspectSvg />

          <span className="p-1 w-3/4 text-lg text-center text-white bg-lime-green rounded-lg md:w-full">
            {i18n.t(
              "reconditionedSmartphones.process.inspection",
              {},
              { html: true },
            )}
          </span>
        </div>

        <div className="self-center rotate-90 md:rotate-0">
          <ArrowSvg />
        </div>

        <div className="flex flex-col flex-1 gap-4 items-center">
          <ReparationSvg />

          <span className="p-1 w-3/4 text-lg text-center text-white bg-lime-green rounded-lg md:w-full">
            {i18n.t(
              "reconditionedSmartphones.process.reparation",
              {},
              { html: true },
            )}
          </span>
        </div>

        <div className="self-center rotate-90 md:rotate-0">
          <ArrowSvg />
        </div>

        <div className="flex flex-col flex-1 gap-4 items-center">
          <TestSvg />

          <span className="p-1 w-3/4 text-lg text-center text-white bg-lime-green rounded-lg md:w-full">
            {i18n.t(
              "reconditionedSmartphones.process.test",
              {},
              { html: true },
            )}
          </span>
        </div>

        <div className="self-center rotate-90 md:rotate-0">
          <ArrowSvg />
        </div>

        <div className="flex flex-col flex-1 gap-4 items-center">
          <CleanSvg />

          <span className="p-1 w-3/4 text-lg text-center text-white bg-lime-green rounded-lg md:w-full">
            {i18n.t(
              "reconditionedSmartphones.process.clean",
              {},
              { html: true },
            )}
          </span>
        </div>
      </div>
    </div>
  );
};
